<template>
  <v-app>
    <Navbar/>
    <div class="admin_setting">
     <v-content>
        <!--<v-btn class="ilang" v-for="entry in languages" :key="entry.title" @click="changeLocale(entry.language)">   
               <flag :iso="entry.flag" v-bind:squared=false />  {{entry.title}}    </v-btn>-->
    <v-menu offset-y>
      <template slot="activator" slot-scope="{ on }">
        <v-btn color="#F16D07"  dark v-on="on" >
          Select Language
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-for="entry in languages" :key="entry.title" @click="changeLocale(entry.language)">
          <v-list-item-title class="lang-list"><flag :iso="entry.flag" v-bind:squared=false />{{entry.title}}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu> 

        <form @submit.prevent="editEmail">
          <v-card>
            <v-card-title class="grey lighten-4 py-4 center">
              <h4>{{ $t('Update')}} Email</h4>
            </v-card-title>
            <v-container grid-list-sm class="pa-4">
              <v-flex xs10 align-center justify-space-between>
                <v-text-field
                  v-model="email"
                  name="email"
                  placeholder="Email"
                  type="email"
                  required
                  disabled>
                </v-text-field>
              </v-flex>
              <v-flex xs10>
                <v-btn type="submit" block class="main_color" dark>Email {{ $t('Update')}}</v-btn>
              </v-flex>
              <p class="feedback-successful" v-if="emailFeedback">{{emailFeedback}}</p>
            </v-container>
          </v-card>
        </form>

        <form @submit.prevent="editPassword">
          <v-card>
            <v-card-title class="grey lighten-4 py-4 center">
              <h4>{{ $t('Update')}} {{ $t('Password')}}</h4>
            </v-card-title>
            <v-container grid-list-sm class="pa-4">
              <v-flex xs10 align-center justify-space-between>
                 <v-text-field
                  v-model="password"
                  name="password"
                  v-bind:placeholder="$t('New_password')"
                  type="password"
                  required
                  disabled>
                 </v-text-field>
              </v-flex>
              <v-flex xs10>
                <v-btn type="submit" block class="main_color" dark>{{ $t('Password')}} {{ $t('Update')}}</v-btn>
              </v-flex>
              <p class="feedback-successful" v-if="passowrdFeedback">{{passowrdFeedback}}</p>
            </v-container>
          </v-card>
        </form>

        <form @submit.prevent="changeCurrency">
          <v-card>
            <v-card-title class="grey lighten-4 py-4 center">
            <h4>{{ $t('Update')}} {{ $t('Currency')}}</h4>
            </v-card-title>
            <v-container grid-list-sm class="pa-4">
              <v-layout row wrap>
                <v-flex xs10 align-center justify-space-between>
                  <v-layout align-center>
                    <v-text-field
                      prepend-icon="local_atm"
                      v-bind:placeholder="$t('Currency')"
                      v-model="currency"
                    ></v-text-field>
                  </v-layout>
                </v-flex>
                <v-flex xs10>
                  <v-btn type="submit" block class="main_color" dark>{{ $t('Currency')}} {{ $t('Update')}}</v-btn>
                </v-flex>
                <p class="feedback-successful" v-if="currencyFeedback">{{currencyFeedback}}</p>
              </v-layout>
            </v-container>
          </v-card>
        </form>

        <form @submit.prevent="changeTax">
          <v-card>
            <v-card-title class="grey lighten-4 py-4 center">
            <h4>{{ $t('Update')}} {{ $t('Tax')}} %</h4>
            </v-card-title>
            <v-container grid-list-sm class="pa-4">
              <v-layout row wrap>
                <v-flex xs10 align-center justify-space-between>
                  <v-layout align-center>
                    <v-text-field
                      prepend-icon="local_atm"
                      v-bind:placeholder="$t('Tax')"
                      v-model="tax"
                    ></v-text-field>
                  </v-layout>
                </v-flex>
                <v-flex xs10>
                  <v-btn type="submit" block class="main_color" dark>{{ $t('Tax')}} {{ $t('Rate')}} {{ $t('Update')}}</v-btn>
                </v-flex>
                <p class="feedback-successful" v-if="taxFeedback">{{taxFeedback}}</p>
              </v-layout>
            </v-container>
          </v-card>
        </form>

        <form @submit.prevent="changeVat">
          <v-card>
            <v-card-title class="grey lighten-4 py-4 center">
            <h4>{{ $t('Update')}} {{ $t('Vat')}} %</h4>
            </v-card-title>
            <v-container grid-list-sm class="pa-4">
              <v-layout row wrap>
                <v-flex xs10 align-center justify-space-between>
                  <v-layout align-center>
                    <v-text-field
                      prepend-icon="local_atm"
                      v-bind:placeholder="$t('Vat')"
                      v-model="vat"
                    ></v-text-field>
                  </v-layout>
                </v-flex>
                <v-flex xs10>
                  <v-btn type="submit" block class="main_color" dark>{{ $t('Vat')}} {{ $t('Rate')}} {{ $t('Update')}}</v-btn>
                </v-flex>
                <p class="feedback-successful" v-if="vatFeedback">{{vatFeedback}}</p>
              </v-layout>
            </v-container>
          </v-card>
        </form>


        <form @submit.prevent="changeCompanyName">
          <v-card>
            <v-card-title class="grey lighten-4 py-4 center">
              <h4>{{ $t('Company')}} {{ $t('Name')}}</h4>
            </v-card-title>
            <v-container grid-list-sm class="pa-4">
              <v-layout row wrap>
                <v-flex xs10 align-center justify-space-between>
                  <v-layout align-center>
                    <v-text-field
                      prepend-icon="local_atm"
                      v-bind:placeholder="$t('Company_name')"
                      v-model="company_name"
                    ></v-text-field>
                  </v-layout>
                </v-flex>
                <v-flex xs10>
                  <v-btn type="submit" block class="main_color" dark>{{ $t('Company')}} {{ $t('Name')}} {{ $t('Update')}}</v-btn>
                </v-flex>
                <p class="feedback-successful" v-if="companyNameFeedback">{{companyNameFeedback}}</p>
              </v-layout>
            </v-container>
          </v-card>
        </form>

        <form @submit.prevent="changeCompanyAddress">
          <v-card>
            <v-card-title class="grey lighten-4 py-4 center">
              <h4>{{ $t('Company')}} {{ $t('Address')}}</h4>
            </v-card-title>
            <v-container grid-list-sm class="pa-4">
              <v-layout row wrap>
                <v-flex xs10 align-center justify-space-between>
                  <v-layout align-center>
                    <v-text-field
                      prepend-icon="local_atm"
                      v-bind:placeholder="$t('Company_address')"
                      v-model="company_address"
                    ></v-text-field>
                  </v-layout>
                </v-flex>
                <v-flex xs10>
                  <v-btn type="submit" block class="main_color" dark>{{ $t('Company')}} {{ $t('Address')}} {{ $t('Update')}}</v-btn>
                </v-flex>
                <p class="feedback-successful" v-if="companyAddressFeedback">{{companyAddressFeedback}}</p>
              </v-layout>
            </v-container>
          </v-card>
        </form>

        <form @submit.prevent="changeCompanyMobile">
          <v-card>
            <v-card-title class="grey lighten-4 py-4 center">
              <h4>{{ $t('Company')}} {{ $t('Mobile_number')}}</h4>
            </v-card-title>
            <v-container grid-list-sm class="pa-4">
              <v-layout row wrap>
                <v-flex xs10 align-center justify-space-between>
                  <v-layout align-center>
                    <v-text-field
                      prepend-icon="local_atm"
                      v-bind:placeholder="$t('Company_mobile')"
                      v-model="company_mobile"
                    ></v-text-field>
                  </v-layout>
                </v-flex>
                <v-flex xs10>
                  <v-btn type="submit" block class="main_color" dark>{{ $t('Company')}} {{ $t('Mobile_number')}} {{ $t('Update')}}</v-btn>
                </v-flex>
                <p class="feedback-successful" v-if="companyMobileFeedback">{{companyMobileFeedback}}</p>
              </v-layout>
            </v-container>
          </v-card>
        </form>
       
       
      </v-content>
    </div>
  </v-app>
</template>

<script>
  import Navbar from '@/components/admin/navbar/Navbar'
  import firebase from 'firebase'
  import moment from 'moment'
  import {i18n} from '@/plugins/i18n'
  export default {
    name:'Settings',
    components: {
      Navbar
    },
    data(){
      return{
        passowrdFeedback:'',
        currencyFeedback:'',
        taxFeedback:'',
        password:null,
        newPassword:null,
        userCurrentEmail:'',
        currency:'',
        tax:null,
        vat:null,
        vatFeedback:null,
        email:'',
        emailFeedback:'',
        shipping:'',
        shippingFeedback:'',
        company_name:'',
        companyNameFeedback:'',
        company_address:'',
        companyAddressFeedback:'',
        company_mobile:'',
        companyMobileFeedback:'',
        about_page_text:'',
        aboutPageTextFeedback:'',
        security_pin:'',
        securityPinFeedback:'',
        languages: [            
            {flag: 'us', 
            language: 'en', 
            title: 'English' 
            },    
              
           {flag: 'pt',
           language: 'pt',
            title: 'Portuguese' 
            },
            {flag: 'tr',
           language: 'tr',
            title: 'Turkish' 
            },
            

            ],      
      }
    },
    created(){
      // Current User
      var user = firebase.auth().currentUser;
      if (user) {
          this.userId = user.uid
          this.email = user.email
          this.userLoggedin = true;                
      } else {
          this.userLoggedin = false;            
      }
      // Current Currency
      var db = firebase.firestore();
      db.collection("settings").doc('config').onSnapshot(doc =>{
        this.currency = doc.data().currency
      })

      // Current Tax
      var db = firebase.firestore();
      db.collection("settings").doc('config').onSnapshot(doc =>{
        this.tax = doc.data().tax
      })

      // Current Vat
      var db = firebase.firestore();
      db.collection("settings").doc('config').onSnapshot(doc =>{
        this.vat = doc.data().vat
      })

      // Current Shipping
      var db = firebase.firestore();
      db.collection("settings").doc('config').onSnapshot(doc =>{
        this.shipping = doc.data().shipping
      })
      
      // Company Name
      var db = firebase.firestore();
      db.collection("settings").doc('config').onSnapshot(doc =>{
        this.company_name = doc.data().company_name
      })
      
      // Company Address
      var db = firebase.firestore();
      db.collection("settings").doc('config').onSnapshot(doc =>{
        this.company_address = doc.data().company_address
      })

      // Company Mobile
      var db = firebase.firestore();
      db.collection("settings").doc('config').onSnapshot(doc =>{
        this.company_mobile = doc.data().company_mobile
      })

      // About page text
      var db = firebase.firestore();
      db.collection("settings").doc('config').onSnapshot(doc =>{
        this.about_page_text = doc.data().about_page_text
      })

      // Security PIN
      var db = firebase.firestore();
      db.collection("settings").doc('config').onSnapshot(doc =>{
        this.security_pin = doc.data().security_pin
      })
    },
    methods:{
      editEmail(){
        var user = firebase.auth().currentUser;         

        user.updateEmail(this.email)
        .then(() => {             
          firebase.auth().signOut()
          this.$router.replace('/setup')                  
        }).catch((error) => {
          this.emailFeedback = error.message
        });
      },    
      editPassword(){
        var user = firebase.auth().currentUser;  

        user.updatePassword(this.password)
        .then(() => {             
          firebase.auth().signOut()
          this.$router.replace('/setup')               
        }).catch(function(error) {
          console.log(error);
        }); 
      },    
      changeCurrency(){
        if(this.currency){
        var db = firebase.firestore();  
        let ref = db.collection('settings').doc('config');
          ref.update({
            currency:this.currency
          })
          this.currencyFeedback="Currency updated successfully"
        }
      },
      changeLocale(locale) {        
        i18n.locale = locale;   
        
        },
      changeTax(){
        if(this.tax){
        var db = firebase.firestore();  
        let ref2 = db.collection('settings').doc('config');
          ref2.update({
            tax:this.tax
          })
          this.taxFeedback="Tax rate updated successfully"
        }
      },
      changeVat(){
        if(this.vat){
        var db = firebase.firestore();  
        let ref2 = db.collection('settings').doc('config');
          ref2.update({
            vat:this.vat
          })
          this.vatFeedback="Vat rate updated successfully"
        }
      },
      changeShipping(){
        if(this.shipping){
        var db = firebase.firestore();  
        let ref3 = db.collection('settings').doc('config');
          ref3.update({
            shipping:this.shipping
          })
          this.shippingFeedback="Shipping fee updated successfully"
        }
      },
      changeCompanyName(){
        if(this.company_name){
        var db = firebase.firestore();  
        let ref3 = db.collection('settings').doc('config');
          ref3.update({
            company_name:this.company_name
          })
          this.companyNameFeedback="Comapny Name updated successfully"
        }
      },
      changeCompanyMobile(){
        if(this.company_mobile){
        var db = firebase.firestore();  
        let ref3 = db.collection('settings').doc('config');
          ref3.update({
            company_mobile:this.company_mobile
          })
          this.companyMobileFeedback="Comapny Mobile updated successfully"
        }
      },
      changeCompanyAddress(){
        if(this.company_address){
        var db = firebase.firestore();  
        let ref3 = db.collection('settings').doc('config');
          ref3.update({
            company_address:this.company_address
          })
          this.companyAddressFeedback="Comapny Address updated successfully"
        }
      },
      changeAboutPageText(){
        if(this.about_page_text){
        var db = firebase.firestore();  
        let ref3 = db.collection('settings').doc('config');
          ref3.update({
            about_page_text:this.about_page_text
          })
          this.aboutPageTextFeedback="About page text updated successfully"
        }
      },
      changeSecurityPin(){
        if(this.security_pin){
        var db = firebase.firestore();  
        let ref3 = db.collection('settings').doc('config');
          ref3.update({
            security_pin:this.security_pin
          })
          this.securityPinFeedback="Security PIN updated successfully"
        }
      },
    }
  }
</script>

<style>
  .feedback-successful{
    color: green;
    text-align: center;
  }
  h4{
    margin-left: 1%;
  }
  .v-text-field__slot .primary--text {
  color: #F16D07 !important;
  caret-color: #F16D07 !important;
}
.admin_setting .primary--text {
  color: #F16D07 !important;
  caret-color: #F16D07 !important;
}
.ilang{    
        
  font-size: 14px;    
  margin: 15px;
  padding: 2px;
  color: #F16D07 !important;
  
  }
  .lang-list{
    display: block;
    cursor: pointer;
    padding: 7px;
  }
  .lang-list:hover{
    background-color: #F16D07 !important;
    color: cornsilk;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/settings/Settings.vue